
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.255 24a.75.75 0 01-.75-.75 6.758 6.758 0 00-6.75-6.75h-2.25v2.163a2.245 2.245 0 01-2.249 2.247 2.255 2.255 0 01-1.65-.719l-5.46-5.915a2.262 2.262 0 010-3.051l5.46-5.915a2.255 2.255 0 011.648-.721h.037c.578 0 1.13.234 1.554.658.426.424.66.989.661 1.59L13.505 9h2.25c4.549 0 8.25 3.701 8.25 8.25v6c0 .413-.337.75-.75.75zM11.257 6.089a.752.752 0 00-.55.24l-5.46 5.913a.754.754 0 000 1.017l5.459 5.914a.75.75 0 001.299-.51V15.75a.75.75 0 01.75-.75h3a8.298 8.298 0 016.75 3.512V17.25a6.758 6.758 0 00-6.75-6.75h-3a.743.743 0 01-.53-.22.743.743 0 01-.22-.531l.002-2.913a.747.747 0 00-.75-.747z"}}),_c('path',{attrs:{"d":"M6.613 20.431a.751.751 0 01-.551-.241L.604 14.276a2.262 2.262 0 010-3.051L6.061 5.31a.75.75 0 111.103 1.017l-5.458 5.914a.754.754 0 000 1.017l5.458 5.914a.752.752 0 01-.551 1.259z"}})])
          )
        }
      }
    